<template lang="pug">
div
  h1
    img(src='~@/assets/img/logo.png')
  el-menu(mode='vertical', :default-active='$route.path', background-color='#304156', text-color='#bfcbd9', active-text-color='#409EFF')
    router-link(to="/dashboard/", key='dashboard')
      el-menu-item(index="dashboard")
        span Dashboard
    router-link(to="/top/", key='top')
      el-menu-item(index="top")
        span TOP管理
    router-link(to="/works/", key='works')
      el-menu-item(index="works")
        span Works
    router-link(to="/talent/", key='talent')
      el-menu-item(index="talent")
        span Talents
    router-link(to="/press/", key='press')
      el-menu-item(index="press")
        span Press
    router-link(to="/newsletter/", key='newsletter')
      el-menu-item(index="newsletter")
        span Newsletter
    router-link(to="/merged_news/", key='mergedNews')
      el-menu-item(index="mergedNews")
        span MargedNews
    router-link(to="/stories/", key='stories')
      el-menu-item(index="stories")
        span Stories
    router-link(to="/studio/", key='studio')
      el-menu-item(index="studio")
        span Studio
    router-link(to="/careers/", key='careers')
      el-menu-item(index="careers")
        span Careers
</template>

<script>
export default {
  name: 'BaseLayoutTheSidebar'
}
</script>



// WEBPACK FOOTER //
// src/components/Base/Layout/TheSidebar/index.vue